import {Splide} from '@splidejs/splide';
import '@splidejs/splide/css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { windowWidth } from './utils';

const sliders = {
    init() {
        this.heroSlider();
        this.prodSlider();
        this.textSlider();
        this.topTxtSlider();
        this.subCats();
        this.setProdThumbnailsSlider();
        this.setProdGallerySlider();
        this.resetSlider();
    },

    resetSlider() {
        window.addEventListener('reset', () => {
            this.setProdThumbnailsSlider();
            this.setProdGallerySlider();
        });
    },


heroSlider() {
    const sliders = document.querySelectorAll('.jsHeroSlider') as NodeListOf<HTMLElement>;

    const loadSlideAssets = (slide: HTMLElement | null) => {
        if (!slide || slide.dataset.assetsLoaded === 'true') return;

        const picture = slide.querySelector('picture');
        if (!picture) return;

        const sources = picture.querySelectorAll('source[data-srcset]');
        const img = picture.querySelector('img[data-src]') as HTMLImageElement | null;

        sources.forEach((source) => {
            const dataSrcset = source.getAttribute('data-srcset');
            if (dataSrcset) {
                source.setAttribute('srcset', dataSrcset);
                source.removeAttribute('data-srcset');
            }
        });

        if (img) {
            const dataSrc = img.getAttribute('data-src');
            if (dataSrc) {
                img.setAttribute('src', dataSrc);
                img.removeAttribute('data-src');
            }
        }

        slide.dataset.assetsLoaded = 'true';
    };

    sliders.forEach((el) => {
        const slider = new Splide(el, {
            type: 'slide',
            rewind: true,
            perPage: 1,
            pagination: true,
            arrows: true,
        });

        slider.on('mounted move', () => {
            const activeSlide = el.querySelector('.splide__slide.is-active') as HTMLElement | null;
            const prevSlide = el.querySelector('.splide__slide.is-prev') as HTMLElement | null;
            const nextSlide = el.querySelector('.splide__slide.is-next') as HTMLElement | null;

            loadSlideAssets(activeSlide);
            loadSlideAssets(prevSlide);
            loadSlideAssets(nextSlide);
        });

        slider.mount();
    });
},


        topTxtSlider() {
        const sliders = document.querySelectorAll('.jsTopTxt') as NodeListOf<HTMLElement>;

        sliders.forEach((item) => {
            new Splide(item, {
            perPage: 1,
            type: "fade",
            speed: 2000,
            arrows: false,
            pagination: false,
            cover: false,
            autoplay: true,
            rewind: true,
            reducedMotion: {
            interval: 4000,
            speed: 800,
            autoplay: true,
            },
            }).mount();
        });
        },

    prodSlider() {
        const sliders = document.querySelectorAll('.jsProdSlider') as NodeListOf<HTMLElement>;

        sliders.forEach((item) => {
            new Splide(item, {
                type: 'slide',
                arrows: false,
                gap: 25,
                perPage: 5,
                pagination: true,
                rewind: true,
                breakpoints: {
                    1200: {
                        perPage: 2,
                        perMove: 1,
                        padding: {right: '40%'},
                    },

                    767: {
                        perPage: 1,
                        perMove: 1,
                        padding: {right: '40%'},   
                    }
                    
                    
                },
            }).mount();
        });
    },

    textSlider() {
    const sliders = document.querySelectorAll(
      '.jsTextSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        perPage: 4,
        pagination: false,
        arrows: false,
        autoWidth: true,
        gap: 50,
        autoScroll: {
          speed: -1,
        },
        breakpoints: {
          768: {
            perPage: 3,
            gap: 35,
          },
          500: {
            perPage: 1,
            padding: { right: '30%' },
          },
        },
      }).mount({ AutoScroll });
    });
    },

        subCats() {

        const sliders = document.querySelectorAll('.jsSubCatSlider') as NodeListOf<HTMLElement>;

        sliders.forEach((item) => {
            new Splide(item, {
                type: 'carousel',
                arrows: true,
                gap: 30,
                perPage: 4,
                rewind: true, 
                pagination: false,
                breakpoints: {
                    1200: {
                        arrows: false,
                        pagination: true,
                        gap: 20,
                        perPage: 3,
                        perMove: 1,
                    },
                    767: {
                        arrows: false,
                        pagination: true,
                        gap: 15,
                        padding: { right: '20%' },
                        perPage: 2,
                        perMove: 1,
                    }
                },
            }).mount();
        })
    },


setProdThumbnailsSlider() {
  const productMainImages = document.getElementById("mainImage") as HTMLElement | undefined
  const thumbnails = document.getElementById("thumbnails") as HTMLElement | undefined

  if (productMainImages && thumbnails) {
    const slideCount = productMainImages.querySelectorAll(".splide__slide").length

    const main = new Splide(productMainImages, {
      type: "fade",
      rewind: true,
      pagination: false,
      arrows: slideCount > 4,
    })

    const thumbnailsNav = new Splide(thumbnails, {
      type: "slide",
      direction: "ttb",
      isNavigation: true,
      pagination: false,
      height: "560px",
      fixedHeight: 140,
      arrows: slideCount > 4,
      gap: "0",
    })

    main.sync(thumbnailsNav)
    main.mount()
    thumbnailsNav.mount()
  }
},

setProdGallerySlider() {
  const productMainImages = document.getElementById("mainImageGallery") as HTMLElement | undefined
  const thumbnails = document.getElementById("thumbnailsGallery") as HTMLElement | undefined

  if (productMainImages && thumbnails) {
    const slideCount = productMainImages.querySelectorAll(".splide__slide").length

    const main = new Splide(productMainImages, {
      type: "fade",
      rewind: true,
      pagination: false,
      arrows: slideCount > 4,
    })

    const thumbnailsNav = new Splide(thumbnails, {
      type: "slide",
      direction: "ttb",
      isNavigation: true,
      pagination: false,
      height: "560px",
      fixedHeight: 140,
      arrows: slideCount > 4,
      gap: "0",
    })

    main.sync(thumbnailsNav)
    main.mount()
    thumbnailsNav.mount()
  }
},

};

export default sliders;


